import { getCookie } from "tiny-cookie"

var runConfig = window.runConfig || {}

export var apiConfig = {
  sentryURL: runConfig.SENTRY_URL || "",
  baseURL: runConfig.API_URL || process.env.VUE_APP_API_URL,
  cableURL: `${runConfig.WS_URL || process.env.VUE_APP_WS_URL}/cable`,
  headers: { Authorization: `Bearer ${getCookie("token")}` }
}
